'use strict';

angular.module('atex.dam').factory('SystemConfig',
['$q', 'ContentService', 'ContentCacheService',
function($q, ContentService, ContentCacheService) {

  var systemConfig = {};

  var isReady = false;

  var systemConfigId = 'atex.configuration.desk-system-configuration';
  var whenReady = ContentCacheService.get(systemConfigId, function() {
    return ContentService.getContent({id: systemConfigId}).then(function (response) {
      var json = atex.onecms.ObjectUtils.getByPath(response, "data/aspects/contentData/data/json");
      return JSON.parse(json);
    });
  }).then(function(config) {
    isReady = true;
    return config;
  });

  var warnIfNotReady = function () {
    if (!isReady) {
      console.warn ("Trying to use SystemConfig before it is ready - change to use a promise");
    }
  };

  systemConfig = {
    whenReady: function () {
      return whenReady;
    },

    getMidnightShiftHours: function () {
      return whenReady.then(function(config) {
        return atex.onecms.ObjectUtils.getByPath(config, "midnightShiftHours");
      });
    },

    getPlausibleConfiguration: function () {
      return whenReady.then(function(config) {
        var plausible = atex.onecms.ObjectUtils.getByPath(config, "statistics/plausible");
        return _.extend({domains: {}}, plausible);
      });
    }
  };

  return systemConfig;

}]);
